<template>
    <customModal :containermd=true :bodyxl = true :footerShow = true @closeModal="closeRecipientModal">
        <template #title>
            <h4 class="my-0"> Assign Signers</h4>
        </template>
        <template #body>
            <form>
                    <div class="form-row mb-3">
                        <div class="col-lg-12">
                            <label class="mb-0">{{ $t('navigations.subject') }} </label>
                            <input 
                                type="text"
                                maxlength="1000"
                                class="form-control"
                                v-model="value.emailSubject"
                                />
                        </div>
                        
                    </div>
                <div class="ibox-title align-items-center bg-light">
                    <h5 class="py-0">Internal User</h5>
                </div>
                <div class="ibox-content mb-2 px-2 py-2">
                    <div class="col-md-12 d-flex align-items-center px-0 gap-1">
                    <div class="col-12 col-md-5 mb-2 px-0">
                    <label for="roleList" class="form-label">{{$t("navigations.role")}}</label>
               <Multiselect
  id="roleList"
  class="multiselect-theme"
  v-model="selectedRoles"
                @update:modelValue="roleChanged" 
                @clear="onClear"
                mode="multiple"
                placeholder="Select roles"
                :options="roleList"
                value-prop="roleID"
                label="roleName"
                track-by="roleName" 
                :searchable="true"
                :hide-selected="false"
                :search-filter="roleSearchFilter"
                >
                <template #option="{ option }">
                    {{ option.roleName }}
                </template>
                </Multiselect>
                </div>
                <div class="col-12 col-md-5 mb-2 px-0">
                    <label for="userList" class="form-label">{{$t("navigations.user")}}</label>
                    <Multiselect
                    v-model="selectedusers"
                    :options="userList"
                    @update:modelValue="userchanged()" 
                    @clear="onClear"
                    mode="multiple"
                    label="name"
                    track-by="name"
                    value-prop="userID"
                    :searchable="true"
                    :search-filter="searchFilter"
                    />
                </div>
                <div class="col-md-2 mb-1 mt-4 text-center px-0">
                            <label class="mb-0 pr-2 ">{{ $t('navigations.sign order') }} </label>
                            <input
                                type="checkbox"
                                v-model="IsOrderedSigning"
                                class="mt-0"
                            />
                        </div>
                </div>
                <!-- {{ selectedUser }} -->
                    <!-- <h4>Users</h4> -->
                    <table class="table table-sm table-bordered table-hover mb-3 custom-user-table" style="width: 100%;">
                      <thead class="thead-light">
                        <tr>
                            <th class="text-center col-user headder-style" style="width: 70%;">{{ $t('navigations.user') }}</th>
                            <th v-if="IsOrderedSigning" class="text-center col-sign-order">{{ $t('navigations.sign order') }}</th>
                            <th class="text-center">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                            <tr
                                    v-for="user in userList"
                                    :key="user.userID"
                                    v-show="selectedUser[user.userID] && selectedUser[user.userID].selected"
                                    class="row-compact text-center"
                                    >
                                    <td class="col-user">{{ user.name }}</td>

                                    <td v-if="IsOrderedSigning" class="text-center">
                                        <input
                                        v-if="selectedUser[user.userID] && selectedUser[user.userID].selected"
                                        type="number"
                                        v-model.number="selectedUser[user.userID].signOrder"
                                        min="1"
                                        step="1"
                                        class="form-control form-control-sm compact-input"
                                        :disabled="!IsOrderedSigning"
                                        @change="normalizeSignOrder(user.userID)"
                                        />
                                    </td>

                                    <td class="col-user">
                                        <i class="fa fa-trash edit-delete" @click.prevent="deletesigner(user.userID)"></i>
                                    </td>
                                    </tr>
                            </tbody>
                    </table>
                </div>
                <!-- <div class="ibox-title d-flex justify-content-between align-items-center bg-light">
                    <h5 class="mb-3">External User</h5>
                     <div class="position-relative" aria-label="Add user">
                        <img
                            class="cursor-pointer"
                            src="../../assets/img/create.png"
                            width="17" height="17" alt="Add user"
                            @click="addExternalUser()"
                        />
                        <div class="tool-tip">Add user</div>
                    </div>
                </div> -->
                <!-- <div class="ibox-content mb-2 px-2 py-2">
                <div v-for="(externalUser, index) in externalUsers" :key="index" class="form-row">
                    <div class="col-lg-4 mb-1">
                        <label class="mb-0">{{ $t('navigations.user name') }} </label>
                        <input 
                            type="text"
                            maxlength="1000"
                            class="form-control"
                            v-model="externalUser.recipientName"
                        />
                    </div>
                    <div class="col-lg-4 mb-1">
                        <label class="mb-0">{{ $t('navigations.email') }} </label>
                        <input 
                            type="text"
                            maxlength="1000"
                            class="form-control"
                            v-model="externalUser.recipientEmail"
                        />
                    </div>
                    <div class="col-lg-2 mb-1">
                        <label class="mb-0">{{ $t('navigations.sign order') }} </label>
                        <input 
                            type="number"
                            maxlength="3"
                            class="form-control"
                            v-model="externalUser.recipientSignOrder"
                        />
                    </div>
                    <div class="col-lg-1 mb-1">
                        <div class="position-relative" aria-label="remove user">
                            <img
                                class="cursor-pointer"
                                src="../../assets/img/remove.png"
                                width="17" height="17" alt="remove user"
                                @click="removeExternalUser(index)"
                            />
                            <div class="tool-tip">Remove user</div>
                        </div>
                    </div>
                </div>
                </div> -->
            </form>
        </template>
        <template #footer>
            <div class="col-lg-12 mt-1 d-flex justify-content-lg-end">
              <button
                class="cancel_btn py-1 px-4 mx-3"
                type="button"
                @click.prevent="clear()"
              >
                {{ $t("navigations.clear") }}
              </button>
              <button
            class="save_btn py-1 px-4 position-relative d-flex align-items-center justify-content-center"
            type="button"
            @click.prevent="createDocuSign()"
            :disabled="loadingDocUpload"
            >
            <span v-if="!loadingDocUpload">
                {{ $t("navigations.save") }}
            </span>

  <!-- Loader (shown when loading) -->
                <div class="toc-loader position-absolute" v-if="loadingDocUpload">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
            </div>
            </button>


            </div>     
        </template>
    </customModal>
</template>
<script src="./ManageDocRecipient.js"></script>
<style scoped>
/* .scrollable{
    max-height: 300px;
    overflow-y: auto;
} */
 .setheight{
    height: 15px;
 }
 .custom-user-table td,
.custom-user-table th {
  padding: 2px 6px;     
  line-height: 1.1;
}

.row-compact td {        
  height: 32px;            
}

.custom-user-table .compact-input {
  height: 24px;     
  padding: 0 6px;
  line-height: 24px;  
}
.headder-style{
 height: 34px;
 font-weight: bold;
}
</style>